import React from 'react';
import { Box, Typography } from '@mui/material';

const CustomChip = ({
  label,
  color = '#F3F4F6',
  textColor = '#334155',
  border = true,
  borderColor = '#E5E7EB',
  icon = null,
  size = 'small',
  rounded = true,
  style = {},
  className = '',
  ...rest
}) => {
  return (
    <Box
      component="span"
      className={className}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        px: size === 'small' ? 1 : 1.5,
        py: size === 'small' ? 0.25 : 0.5,
        fontSize: size === 'small' ? '0.70rem' : '0.875rem',
        fontWeight: 500,
        backgroundColor: color,
        color: textColor,
        border: border ? `1px solid ${borderColor}` : 'none',
        borderRadius: rounded ? '9999px' : '0px',
        lineHeight: 1.2,
        minHeight: size === 'small' ? 22 : 28,
        ...style,
      }}
      {...rest}
    >
      {icon && <Box sx={{ mr: 0.5, display: 'flex', alignItems: 'center' }}>{icon}</Box>}
      <Typography
        component="span"
        sx={{
          fontSize: 'inherit',
          fontWeight: 'inherit',
          color: 'inherit',
          lineHeight: 1.2,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default CustomChip; 